(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-share"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  // Garante que o listener de ESC seja adicionado apenas uma vez,
  // mesmo que initShareCart seja chamado múltiplas vezes após refresh.
  let _escBound = false;

  // ─── Auxiliares ──────────────────────────────────────────────────────────────

  async function _fetchCart() {
    const r = await fetch('/cart.js', { cache: 'no-store' });
    return r.json();
  }

  function _buildShareUrl(cart) {
    if (!cart.items.length) return '';
    const items = cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');
    let url = `${location.origin}/cart/${items}`;
    if (cart.cart_level_discount_applications?.length) {
      const d = cart.cart_level_discount_applications[0].title;
      if (d) url += `?discount=${encodeURIComponent(d)}`;
    }
    return url;
  }

  function _openModal() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const modal = document.querySelector('[data-cart-share-modal]');
    if (!overlay || !modal) return;
    overlay.classList.remove('hidden');
    overlay.classList.add('flex');
    overlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      modal.classList.remove('scale-95', 'opacity-0');
      modal.classList.add('scale-100', 'opacity-100');
    });
  }

  function _closeModal() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const modal = document.querySelector('[data-cart-share-modal]');
    const qrBox = document.querySelector('[data-cart-share-qr-box]');
    if (!overlay || !modal) return;
    modal.classList.add('scale-95', 'opacity-0');
    modal.classList.remove('scale-100', 'opacity-100');
    setTimeout(() => {
      overlay.classList.remove('flex');
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
      if (qrBox) qrBox.classList.add('hidden');
    }, 200);
  }

  function _showToast() {
    const toast = document.querySelector('[data-cart-share-toast]');
    if (!toast) return;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) scale(1)';
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) scale(0.95)';
    }, 1500);
  }

  // ─── Ligação de eventos ───────────────────────────────────────────────────────
  // Chamada após cada refresh do drawer para religar eventos aos novos elementos.

  function _bind() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const copyBtn = document.querySelector('[data-cart-share-copy]');
    const qrBtn   = document.querySelector('[data-cart-share-qr]');
    const qrImg   = document.querySelector('[data-cart-share-qr-img]');
    const qrBox   = document.querySelector('[data-cart-share-qr-box]');

    // Fechar ao clicar fora do modal
    overlay?.addEventListener('click', (e) => {
      if (e.target === overlay) _closeModal();
    });

    // Fechar via ESC — adicionado uma única vez no document
    if (!_escBound) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') _closeModal();
      });
      _escBound = true;
    }

    // Copiar link
    copyBtn?.addEventListener('click', async () => {
      const cart = await _fetchCart();
      const url = _buildShareUrl(cart);
      if (!url) return;
      await navigator.clipboard.writeText(url);
      _showToast();
    });

    // QR Code
    qrBtn?.addEventListener('click', async () => {
      const cart = await _fetchCart();
      const url = _buildShareUrl(cart);
      if (!url || !qrImg || !qrBox) return;
      qrImg.src = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(url)}`;
      qrBox.classList.remove('hidden');
    });
  }

  // Fecha o modal quando o drawer fechar
  document.addEventListener('cartDrawer:closed', _closeModal);

  // ─── Gatilho (delegação no document) ─────────────────────────────────────────
  // Usa delegação para funcionar mesmo após o trigger ser re-renderizado
  // pelo refresh do drawer.

  document.addEventListener('click', async (e) => {
    if (!e.target.closest('[data-cart-share-open]')) return;
    const cart = await _fetchCart();
    const url = _buildShareUrl(cart);
    const waBtn = document.querySelector('[data-cart-share-whatsapp]');
    if (waBtn && url) {
      waBtn.href = `https://wa.me/?text=${encodeURIComponent(`Olha meu carrinho: ${url}`)}`;
    }
    _openModal();
  });

  // ─── Inicialização ─────────────────────────────────────────────────────────────

  window.initShareCart = () => {
    // Após refresh do drawer, re-liga os eventos aos novos elementos renderizados.
    _bind();
    console.log('[CartShare] Initialized');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initShareCart);
  } else {
    window.initShareCart();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-collection-sort]').forEach(root => {
      const toggle = root.querySelector('[data-collection-sort-toggle]');
      const menu = root.querySelector('[data-collection-sort-menu]');
      if (!toggle || !menu) return;

      const closeMenu = () => {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      };

      toggle.addEventListener('click', () => {
        const menuWillClose = !menu.hidden;
        menu.hidden = menuWillClose;
        toggle.setAttribute('aria-expanded', String(!menuWillClose));
      });

      menu.addEventListener('click', event => {
        const option = event.target.closest('[data-sort-value]');
        if (!option) return;

        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', option.dataset.sortValue);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });

      document.addEventListener('click', event => {
        if (!root.contains(event.target)) closeMenu();
      });

      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') closeMenu();
      });
    });

    document.addEventListener('click', event => {
      const toggle = event.target.closest('[data-filter-accordion-toggle]');
      if (!toggle) return;

      const accordion = toggle.closest('[data-filter-accordion]');
      const content = accordion?.querySelector('.collection-filter-accordion-content');
      if (!accordion || !content) return;

      const willOpen = accordion.dataset.open !== 'true';
      accordion.dataset.open = String(willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      content.hidden = !willOpen;
    });

    const initPriceRanges = (scope = document) => {
      scope.querySelectorAll('[data-price-range]').forEach(root => {
        if (root.dataset.priceRangeReady === 'true') return;
        root.dataset.priceRangeReady = 'true';

        const minRange = root.querySelector('[data-price-min-range]');
        const maxRange = root.querySelector('[data-price-max-range]');
        const minValue = root.querySelector('[data-price-min-value]');
        const maxValue = root.querySelector('[data-price-max-value]');
        const minLabel = root.querySelector('[data-price-min-label]');
        const maxLabel = root.querySelector('[data-price-max-label]');
        if (!minRange || !maxRange || !minValue || !maxValue) return;

        const currency = root.dataset.currency || 'BRL';
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        });

        const normalize = value => {
          const parsed = Number.parseFloat(value);
          return Number.isFinite(parsed) ? parsed : 0;
        };

        const formatValue = value => formatter.format(normalize(value));

        const sync = changedRange => {
          const minLimit = normalize(minRange.min);
          const maxLimit = normalize(maxRange.max);
          let nextMin = normalize(minRange.value);
          let nextMax = normalize(maxRange.value);

          if (nextMin > nextMax) {
            if (changedRange === minRange) {
              nextMax = nextMin;
            } else {
              nextMin = nextMax;
            }
          }

          nextMin = Math.max(minLimit, Math.min(nextMin, maxLimit));
          nextMax = Math.max(minLimit, Math.min(nextMax, maxLimit));

          minRange.value = nextMin;
          maxRange.value = nextMax;
          minValue.value = nextMin <= minLimit ? '' : nextMin.toFixed(2);
          maxValue.value = nextMax >= maxLimit ? '' : nextMax.toFixed(2);

          const minPercent = maxLimit > minLimit ? ((nextMin - minLimit) / (maxLimit - minLimit)) * 100 : 0;
          const maxPercent = maxLimit > minLimit ? ((nextMax - minLimit) / (maxLimit - minLimit)) * 100 : 100;
          root.style.setProperty('--range-min', `${minPercent}%`);
          root.style.setProperty('--range-max', `${maxPercent}%`);

          if (minLabel) minLabel.textContent = formatValue(nextMin);
          if (maxLabel) maxLabel.textContent = formatValue(nextMax);
        };

        minRange.addEventListener('input', () => sync(minRange));
        maxRange.addEventListener('input', () => sync(maxRange));
        sync();
      });
    };

    initPriceRanges();

    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) initPriceRanges(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["home-product-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__homeProductPanelBooted) return;
    window.__homeProductPanelBooted = true;

    function closePanels() {
      document.querySelectorAll('.home-product-panel.panel-open').forEach(function (panel) {
        panel.classList.remove('panel-open');

        var button = panel.querySelector('.home-product-panel__thumb');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 1024) return;

      var thumb = e.target.closest('.home-product-panel__thumb');
      var inPanel = e.target.closest('.home-product-panel');

      if (thumb) {
        e.preventDefault();

        var panel = thumb.closest('.home-product-panel');
        var wasOpen = panel.classList.contains('panel-open');

        closePanels();

        if (!wasOpen) {
          panel.classList.add('panel-open');
          thumb.setAttribute('aria-expanded', 'true');
        }

        return;
      }

      if (!inPanel) {
        closePanels();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024) {
        closePanels();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initNewsletterPopup = () => {
      const popup = document.querySelector('[data-newsletter-popup]');
      if (!popup) return;

      const storageKey = popup.dataset.newsletterPopupStorageKey;
      const delay = Number(popup.dataset.newsletterPopupDelay || 0);
      const duration = Number(popup.dataset.newsletterPopupDuration || 0);
      const maxDismissals = Math.max(0, Number(popup.dataset.newsletterPopupMaxDismissals || 3));
      let closeTimer;

      const getSavedState = () => {
        try {
          return window.localStorage.getItem(storageKey);
        } catch (error) {
          return null;
        }
      };

      const saveState = (state) => {
        try {
          window.localStorage.setItem(storageKey, state);
        } catch (error) {
          // Ignore storage restrictions and keep the popup usable in-session.
        }
      };

      const closePopup = (countDismissal = false) => {
        window.clearTimeout(closeTimer);
        popup.classList.remove('is-visible');
        document.body.classList.remove('newsletter-popup-open');
        if (countDismissal) {
          const currentDismissals = parseInt(getSavedState(), 10) || 0;
          saveState(String(currentDismissals + 1));
        }
        window.setTimeout(() => {
          popup.hidden = true;
        }, 220);
      };

      const openPopup = () => {
        popup.hidden = false;
        document.body.classList.add('newsletter-popup-open');
        window.requestAnimationFrame(() => {
          popup.classList.add('is-visible');
        });

        if (duration > 0) {
          closeTimer = window.setTimeout(() => closePopup(false), duration);
        }
      };

      popup.addEventListener('click', (event) => {
        const closeTrigger = event.target.closest('[data-newsletter-popup-close], [data-newsletter-popup-dismiss]');
        if (closeTrigger) {
          closePopup(true);
          return;
        }

        const startButton = event.target.closest('[data-newsletter-popup-start]');
        if (!startButton) return;

        const initialPanel = popup.querySelector('[data-newsletter-popup-initial]');
        const formPanel = popup.querySelector('[data-newsletter-popup-form-panel]');
        if (initialPanel) initialPanel.hidden = true;
        if (formPanel) formPanel.hidden = false;
        popup.querySelector('#newsletter-popup-name')?.focus();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
          closePopup(true);
        }
      });

      const hasServerSuccess = popup.dataset.newsletterPopupSuccess === 'true';
      const hasServerError = popup.dataset.newsletterPopupError === 'true';
      if (hasServerSuccess) {
        saveState('subscribed');
        openPopup();
        return;
      }

      const savedState = getSavedState();
      const hasReachedDismissalLimit = maxDismissals > 0 && (parseInt(savedState, 10) || 0) >= maxDismissals;
      if (hasServerError || hasReachedDismissalLimit || savedState === 'subscribed') {
        if (hasServerError) openPopup();
        return;
      }

      window.setTimeout(openPopup, delay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNewsletterPopup, { once: true });
    } else {
      initNewsletterPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const swatch = event.target.closest('[data-color-swatch]')

    if (!swatch) return

    const wrapper = swatch.parentElement

    if (!wrapper) return

    const swatches = wrapper.querySelectorAll('[data-color-swatch]')

    swatches.forEach(function (item) {
      item.dataset.selected = 'false'
      item.setAttribute('aria-pressed', 'false')
    })

    swatch.dataset.selected = 'true'
    swatch.setAttribute('aria-pressed', 'true')
  })
  } catch(e) { console.error(e); }
})();

})();
